import React, { useContext } from 'react';
import { SkeletonLine } from 'src/components/Helpers/SkeletonLine';
import { Svg } from 'src/components/Svg/Svg';

import { Button } from '../Button/Button';

import { FilterModalContext } from './FilterModalContext';
import classes from './Toolbar.scss';

type Props = {
    loading?: boolean;
    sorter?: React.ReactNode;
    stats?: React.ReactNode;
};

export const ToolbarLayout: React.FunctionComponent<Props> = ({ loading, sorter, stats }) => {
    const { openFilter } = useContext(FilterModalContext);

    return (
        <div className={classes.toolbar}>
            <Button className={classes.toolbarFilter} onClick={openFilter}>
                <Svg className={classes.toolbarFiltersIcon} name="filters" />
                Show Filters
            </Button>
            {Boolean(stats && sorter) && (
                <>
                    <div className={classes.toolbarSort}>{sorter}</div>
                    <div className={classes.toolbarCount}>
                        <p className={classes.toolbarCountText}>{loading ? <SkeletonLine width={10} /> : stats}</p>
                    </div>
                </>
            )}
        </div>
    );
};
